// src/pages/painel/Painel.jsx
import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-hot-toast";
import { AnimatePresence, motion } from "framer-motion";

// Componentes
import HeaderPainel from "./HeaderPainel";
import AtualizacaoSistema from "../AtualizacaoSistema";
import BoasVindas from "../BoasVindas";
import MenuNavegacao from "../menu/MenuNavegacao";

// Config
import { API_URL } from "../../config";

export default function Painel() {
  const navigate = useNavigate();
  const location = useLocation();
  const [usuario, setUsuario] = useState(null);
  const [relatoriosOpen, setRelatoriosOpen] = useState(false);
  const [configuracoesOpen, setConfiguracoesOpen] = useState(false);
  const [parametrosOpen, setParametrosOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [loadingLogout, setLoadingLogout] = useState(false);
  const [mostrarAtualizacao, setMostrarAtualizacao] = useState(false);

  useEffect(() => {
    const usuarioLocal = localStorage.getItem("usuario");
    if (usuarioLocal) {
      try {
        const user = JSON.parse(usuarioLocal);
        setUsuario(user);

        fetch(`${API_URL}/get_versao.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id_usuario: user.id }),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.mostrar_novidades) {
              setMostrarAtualizacao(true);
            }
          })
          .catch((err) => console.error("Erro ao verificar versão:", err));
      } catch (e) {
        console.error("Erro ao analisar o usuário:", e);
        navigate("/");
      }
    } else {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);

  useEffect(() => {
    setRelatoriosOpen(false);
    setConfiguracoesOpen(false);
    setParametrosOpen(false);
    setMenuOpen(false);
  }, [location]);

  const handleLogout = () => {
    setLoadingLogout(true);
    localStorage.removeItem("usuarioLogado");
    localStorage.removeItem("usuario");
    toast.success("Logout realizado!");
    setLoadingLogout(false);
    navigate("/");
  };

  const toggleSubMenu = (menu) => {
    setRelatoriosOpen(menu === "relatorios" ? !relatoriosOpen : false);
    setConfiguracoesOpen(menu === "configuracoes" ? !configuracoesOpen : false);
    setParametrosOpen(menu === "parametros" ? !parametrosOpen : false);
  };

  const isActive = (path) => location.pathname.startsWith(path);
  const isFullScreenPage = location.pathname === "/painel/whatsapp";

  return (
    <div
      className="min-h-screen w-full font-comfortaa"
      style={{ backgroundColor: "#e2e2e2" }}
    >
      {/* Header */}
      <HeaderPainel
        usuario={usuario}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        handleLogout={handleLogout}
        loadingLogout={loadingLogout}
      />

      {/* Menu */}
      <MenuNavegacao
        isActive={isActive}
        relatoriosOpen={relatoriosOpen}
        configuracoesOpen={configuracoesOpen}
        parametrosOpen={parametrosOpen}
        toggleSubMenu={toggleSubMenu}
      />

      {mostrarAtualizacao && usuario && (
        <AtualizacaoSistema
          usuarioId={usuario.id}
          onFinalizado={() => setMostrarAtualizacao(false)}
        />
      )}

      {/* Conteúdo com animação Framer Motion */}
      <AnimatePresence mode="wait">
        <motion.main
          key={location.pathname}
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 100 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
          className={`${isFullScreenPage ? "p-0 pt-0" : "pt-4 px-2"} h-full`}
          style={{ backgroundColor: "transparent" }}
        >
          {location.pathname === "/painel" ? <BoasVindas /> : <Outlet />}
        </motion.main>
      </AnimatePresence>
    </div>
  );
}
